const endpoints = {
  profileData: 'api/v2/users/user-id',
  profileUpdate: 'Api/profile',
  profilePasswordUpdate: 'Api/profile',
  promocodes: 'api/v2/users/user-id/promocodes',
}

export default endpoints
